import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import emailImage from "@app/assets/email/top-nav-modal-image.svg";

import styles from "./EmailFeatureInfo.module.scss";
import messages from "./messages";

interface Props {}

const EmailFeatureInfo: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <img alt="email-img" src={emailImage} />
      <div className={styles.textContainer}>
        <div className={styles.title}>{intl.formatMessage(messages.notSupportedTitle)}</div>
        <div className={styles.description}>
          {intl.formatMessage(messages.notSupportedDescription)}
        </div>
        <div className={styles.interestedDescription}>
          {intl.formatMessage(messages.notSupportedInterestedDescription)}
        </div>
      </div>
      <div>
        <Button
          href="https://share.hsforms.com/1z8c5Kt06SF6ejeJAkG5WBA3is1h"
          target="_blank"
          type="primary"
        >
          {intl.formatMessage(messages.notSupportedInterested)}
        </Button>
      </div>
    </div>
  );
};
export default EmailFeatureInfo;
